export function getCommentsSectionId(postSlug: string): string {
  return `comments-${postSlug}`;
}
